import { assetsSlice } from './index';
import { httpLoad } from '../../lib/httpLoad';

export function assetLoader(assetList, dispatch) {
	const fetchingUrlList = assetList.map(({ url, type }) => {
		const callback = (error, request) => {
			if (error) {
				dispatch(assetsSlice.actions.fetchFailure({
					url,
					type,
					error,
				}));
				return;
			}

			dispatch(assetsSlice.actions.fetchSuccess({
				type,
				url,
				data: request,
			}));
		};

		httpLoad(url, callback);
		return url;
	});

	dispatch(assetsSlice.actions.fetchPending(fetchingUrlList));
}
